import React, { useState } from "react";
import "./PriceModal.css";

function PriceModal({ sensor, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: ""
  });

  const [showPrice, setShowPrice] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Later you can send this data to backend
    setShowPrice(true);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>✖</button>

        {!showPrice ? (
          <>
            <h4 className="text-center mb-3">Enter Your Details</h4>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Contact Number</label>
                <input
                  type="tel"
                  name="contact"
                  className="form-control"
                  value={formData.contact}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary w-100">
                Get Price
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <h5>Thank you, {formData.name}!</h5>
            <h4 className="mt-3">Price: ₹{sensor.price}</h4>
          </div>
        )}
      </div>
    </div>
  );
}

export default PriceModal;
